export default "__VITE_PUBLIC_ASSET__c433d62a__"